export default __webpack_public_path__ + "static/media/2404.458b0889.png";